import themeProperties from '../../../../../src/theme/themeProperties';

const DefaultProfileImageIcon = () => {
  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="48"
        height="48"
        rx="24"
        fill={themeProperties.designSystem.colors.forestGreenTransparent20}
      />
      <g clipPath="url(#clip0_65_29)">
        <path
          d="M26.0541 24.7993C28.5227 23.8038 30.2559 21.4379 30.2559 18.6582C30.2559 14.9865 27.2227 12 23.4936 12C19.7645 12 16.7445 14.9865 16.7445 18.6582C16.7445 21.4379 18.4777 23.8167 20.9463 24.7993C17.1384 25.8595 14.2628 29.1304 14.0002 33.1771C13.9739 33.6425 14.1446 34.1079 14.4598 34.457C14.788 34.8061 15.2607 35 15.7466 35H31.2407C31.7134 35 32.1992 34.8061 32.5275 34.457C32.8558 34.1209 33.0265 33.6425 32.9871 33.1771C32.7245 29.1304 29.8357 25.8465 26.041 24.7993H26.0541Z"
          fill={themeProperties.designSystem.colors.forestGreen}
        />
      </g>
      <defs>
        <clipPath id="clip0_65_29">
          <rect
            width="19"
            height="23"
            fill="white"
            transform="translate(14 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DefaultProfileImageIcon;
